import { createSlice } from "@reduxjs/toolkit";

const filterSlice = createSlice({
  name: "filter",
  initialState: {
    activeCategory: "STUDIO", // Default filter
  },
  reducers: {
    setCategory: (state, action) => {
      state.activeCategory = action.payload;
    },
    resetCategory: (state) => {
      state.activeCategory = "SIGNATURE";
    }
  },
});

export const { setCategory, resetCategory } = filterSlice.actions;
export default filterSlice.reducer;